import gql from 'graphql-tag'

// """分发某个商品给多个经销商"""
export const assignGoodToDealers = gql`
  mutation($dealers: [DealerProportionInput!]!, $goodId: Int!) {
    assignGoodToDealers(
      goodId: $goodId,
      dealers: $dealers
    )
  }
`

// 删除某个商品从多个经销商
export const removeGoodFromDealers = gql`
  mutation($dealerIds: [Int!]!, $goodId: Int!) {
    removeGoodFromDealers(
      goodId: $goodId,
      dealerIds: $dealerIds
    )
  }
`
